import React from "react";
import { Link } from "react-router-dom";
import styles from "./logo.module.css";
import Logotip from "../../images/logo.png";


function Logo() {

  return (
    <Link className={`${styles.link}`} to="/">
      <img src={ Logotip } alt="Логотип" className={styles.img} />
    </Link>
  );
}

export default Logo;
